import React, { useCallback, useEffect, useState } from "react";
import client from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { EmptyState } from "../components/common";
import { Building2 } from "lucide-react";

export function useFetch(path, { skip = false } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    if (skip || !path) { setLoading(false); return; }
    setLoading(true);
    try {
      const res = await client.get(path);
      setData(res.data);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [path, skip]);

  useEffect(() => { reload(); }, [reload]);
  return { data, loading, error, reload, setData };
}

export function NeedTenant({ children }) {
  const { isSuper, activeTenantId } = useAuth();
  if (isSuper && !activeTenantId) {
    return (
      <EmptyState icon={Building2} title="Select a tenant to continue"
        sub="As super admin, choose a tenant from the switcher in the top bar to explore its process intelligence." />
    );
  }
  return children;
}
